import React from 'react';
import { connect } from "react-redux";
import FooterLeftCol from './FooterLeftCol';
import FooterSocialicons from './FooterSocialicons';
import $ from 'jquery';
import '../../styles/Footer.css';
import chatnowIcon from '../../assets/SVG-Global_Homepage_ProductHome_PLP_FreeTrial/Icon - Chat Bubble - White.svg';
import { Helmet } from "react-helmet";
import FooterNote from '../FooterNoteComponent/FooterNote';
import { Link } from 'react-router-dom';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.loadJs="1";
 }
  componentDidMount(){
    const loadsalesForceLiveagent = (callback) => {
      const existingScript = document.getElementById('salesForceLiveagent');
      if (!existingScript) {
        console.log("Salseforce Chat is offline");
      }else{
        if(window.liveagent && document.getElementById('liveagent_button_online_573d0000000oLnJ') != null && document.getElementById('liveagent_button_online_573d0000000oLnJmob') != null){
          if(window.aload=="1"){
            //console.log("1st"+window.aload);
            $('[id^="liveagent_button_online_573d0000000oLnJ"]').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJ"] > Button').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJ"]').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJ"] > Button').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJmob"]').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJmob"] > Button').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJmob"]').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJmob"] > Button').css('opacity', '1');            
          }else{
            //console.log("2nd"+window.aload);
            var liveagentvar = window.liveagent;
            liveagentvar.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJ'));liveagentvar.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJmob'));liveagentvar.setChatWindowWidth(400);liveagentvar.setChatWindowHeight(600);liveagentvar.init(`https://d.la1w1.salesforceliveagent.com/chat`, '572d0000000oLl8', '00Dd0000000eeku');liveagentvar.addCustomDetail('placeId','2065');liveagentvar.addCustomDetail('fname','',true);liveagentvar.addCustomDetail('lname','',true);liveagentvar.addCustomDetail('email','',true);            
          }
        }else{
          setTimeout(function(){ 
            if(window.liveagent && document.getElementById('liveagent_button_online_573d0000000oLnJ') != null && document.getElementById('liveagent_button_online_573d0000000oLnJmob') != null){
              //console.log("3rd"+window.aload);
              var liveagentvar = window.liveagent;
			        liveagentvar.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJ'));liveagentvar.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJmob'));liveagentvar.setChatWindowWidth(400);liveagentvar.setChatWindowHeight(600);liveagentvar.init(`https://d.la1w1.salesforceliveagent.com/chat`, '572d0000000oLl8', '00Dd0000000eeku');liveagentvar.addCustomDetail('placeId','2065');liveagentvar.addCustomDetail('fname','',true);liveagentvar.addCustomDetail('lname','',true);liveagentvar.addCustomDetail('email','',true);
            }
          }, 2000);
        }
      }
      if (existingScript && callback) callback();
    };
    if(this.loadJs=="1"){this.loadJs="0";loadsalesForceLiveagent();}
    
      $( "div" ).delegate( '[id^="liveagent_button_online_573d0000000oLnJ"]', "click", function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if(window.liveagent){
          window.liveagent.startChat('573d0000000oLnJ');
          }
      });  

  }
  render() {    
    const { error, footerData } = this.props;
    const { footer } = footerData;
    if(footer){
      global.footerNote = footer["footer-menu"].menu.global_footer_note;
    }
    
    var contactstyle = {
      textDecoration : 'none',
      opacity: '0.1'
    };

    if (error) {
      return (
        <div>
          Error:
          {error.message}
        </div>
      );
    }
    return (
      // if api response is not undefined then proceed data binding
      footer !== undefined
      && (
      <>
        {this.props.showFooterNote && <FooterNote/>}
        {/* right footer menu starts  */}
        <div className="container-fluid footer-container">
          {/* <!-- For tablet and mobile view starts --> */}
          <div className="container footer-tablet">
            <div className="row">
              <div className="col-xs-12 col-sm-7">
                <div className="row">
                  <div className="col footer-heading">
                    {/* Have a Question label for Tablet */}
                    <label>{footer['footer-right-menu'].menu.name}</label>
                  </div>
                </div>

                {footer['footer-right-menu'].menu.items && footer['footer-right-menu'].menu.items.map((item) => (
                  item.title === 'Chat Now'
                && (
                <div className="row" key={item.title}>
                  <div className="col">
                  <a href={item.url} id="liveagent_button_online_573d0000000oLnJmob" style={contactstyle} disabled={true} aria-label="chat now"><button type="button" className="chat-btn foolter-content" disabled={true} aria-label="chat now">
                      <span className="chat-img">
                        <img
                          src={chatnowIcon} alt="chat now"
                        />
                      </span>
                      {item.title}
                    </button></a>
                  </div>
                </div>
                )))}
              </div>

              {/* <!-- social media icons --> */}
              <div className="col-xs-12 col-sm-4 contact-us-container">
                { !this.props.showSocialIcons
                && (
                  this.props.leftColData['product-social-links'] !== undefined
                  && <FooterSocialicons IconData={this.props.leftColData['product-social-links'].menu} />
                )}
                {/* Contact us and Shipping Information div starts */}

                {footer['footer-right-menu'].menu.items && footer['footer-right-menu'].menu.items.map((item) => (
                  item.title !== 'Chat Now'
                  && (
                  <div className="row" key={item.title}>
                    <div className="col">
                      <p className="foolter-content"><Link to={item.url}>{item.title}</Link></p>
                    </div>
                  </div>
                  )
                ))}
              </div>
            </div>

          </div>
          {/* <!-- For tablet and mobile view ends --> */}

          <div className="container footer-desktop-container">
            <div className="row">
              {/* right footer navigation for desktop starts  */}
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 order-sm-12 desktop-footer">
                {/* Have a question div */}
                <div className="footer-heading">
                  <label>{footer[`footer-right-menu`].menu.name}</label>
                </div>
                {/* chat now button for desktop */}
                {footer['footer-right-menu'].menu.items && footer['footer-right-menu'].menu.items.map((item) => (
                  item.title === 'Chat Now'
                && (
                <div className="row" key={item.title}>
                  <a href={item.url} id="liveagent_button_online_573d0000000oLnJ" style={contactstyle} disabled={true} aria-label="chat now">
                    <button type="button" className="chat-btn" disabled={true} aria-label="chat now">
                      <span className="chat-img"><img src={chatnowIcon} alt="chat now"/></span>
                      {item.title}
                    </button>
                  </a>
                </div>
                )
                ))}
                <div className="row">
                  {/* Contact us and Return Policy div */}
                  <div className="col-xs-12 contact-us-container">
                    {footer["footer-right-menu"].menu.items && footer["footer-right-menu"].menu.items.map((item) => (
                      item.title !== 'Chat Now'
                      && (
                      <div key={item.title}>
                        <p className="foolter-content" key={item.title}>
                        {(item.url.indexOf('http://') === 0 || item.url.indexOf('https://') === 0)?
                          <a href={item.url}>{item.title}</a>:
                          <Link to={item.url}>{item.title}</Link>
                        }
                        </p>
                      </div>
                      )
                    ))}
                    { !this.props.showSocialIcons
                    && (
                      this.props.leftColData['product-social-links'] !== undefined &&
                      <FooterSocialicons IconData={this.props.leftColData['product-social-links'].menu} />
                    )}
                  </div>
                </div>
              </div>
              {/* right footer navigation for desktop ends  */}

              {/* left footer navigation starts */}
              <FooterLeftCol leftFooter={this.props.leftColData} />
              {/* left footer navigation ends */}

              {/* middle footer navigation starts */}
              <div className="col-xs-12 col-sm-5 col-md-5 col-lg-4 order-sm-4 footer-mobile-padding">
                {/* Wiley Efficient Learning div */}
                <div>
                  <label className="footer-heading">{footer["footer-middle-menu"].menu.name}</label>
                  {footer["footer-middle-menu"].menu.items && footer["footer-middle-menu"].menu.items.map((item) => (
                    <React.Fragment key={item.title}>
                      <p className="foolter-content">
                      {(item.url.indexOf('http://') === 0 || item.url.indexOf('https://') === 0)?
                        <a href={item.url}>{item.title}</a>:
                        <Link to={item.url}>{item.title}</Link>
                      }
                      </p>
                    </React.Fragment>
                  ))}
                </div>
              </div>
              {/* middle footer navigation ends */}

            </div>
          </div>
        </div>

        {/* bottom footer navigation starts */}
        <div className="container-fluid about-us-container">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-xs-12 col-sm-3 col-md-3 col-lg-2 order-sm-12 wiley-logo">
                <div>
                  <img src={footer["footer-menu"].menu.footer_logo} alt="Wiley" width="143px" height="30px" />
                </div>
              </div>
              <div className="col-xs-12 col-sm-7 col-md-8 col-lg-6 order-sm-1 wiley-footer-content">
                {/* Terms Privacy and Sitemap */}
                <div className="row">
                  {footer["footer-menu"].menu.items && footer["footer-menu"].menu.items.map((item) => (
                    item.title === 'Sitemap'
                      ? (
                        <div
                          className="col-3 col-xs-4 col-lg-3 sitemapClass"
                          key={item.title}
                        >
                          <a href={item.url}>
                            <u>
                              {item.title}
                              {' '}
                            </u>
                            {' '}
                          </a>
                        </div>
                      )
                      : (
                        <div
                          className={`col-4 col-xs-4 col-lg-3 ${item.title === 'Privacy Policy' ? "privacy-policy-container" : ""}`}
                          key={item.title}
                        >
                          <a href={item.url}>
                            <u>
                              {item.title}
                              {' '}
                            </u>
                            {' '}
                          </a>
                        </div>
                      )
                  ))}
                </div>
                <div className="row">
                  <div className="col copyright-container">
                    <div>
                      <div dangerouslySetInnerHTML={{ __html: footer["footer-menu"].menu.copyright_content }} />
                      {/* copyright text */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* bottom footer navigation ends */}
        <Helmet>
          <script type="text/javascript">{`
              var aload=0;
              if(!window._laq){window._laq=[];}
              window._laq.push(function(){
                window.liveagent.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJ'));
                window.liveagent.showWhenOnline('573d0000000oLnJ',document.getElementById('liveagent_button_online_573d0000000oLnJmob'));});            
                setTimeout(function(){ 
                  $('[id^="liveagent_button_online_573d0000000oLnJ"]').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJ"] > Button').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJ"]').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJ"] > Button').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJmob"]').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJmob"] > Button').removeAttr("disabled");$('[id^="liveagent_button_online_573d0000000oLnJmob"]').css('opacity', '1');$('[id^="liveagent_button_online_573d0000000oLnJmob"] > Button').css('opacity', '1');
                },1000);
                var aload=1;
            `}</script>
          </Helmet>
      </>
      )
    );    
  }
}
const mapStateToProps = (state) => ({
  footerData: state.HeaderFooterData.items,
  error: state.HeaderFooterData.error,
});

export default connect(mapStateToProps)(Footer);
